import axios from "axios";
import { apiVariable } from "./apiVariable";
import { DriverDto } from "../interfaces/Fleet/DriverDto";

export const getActiveDrivers = async (token: string): Promise<DriverDto[]> => {
  const { data } = await axios.get<DriverDto[]>(
    `${apiVariable}/getAllDrivers`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { areActive: true },
    },
  );

  return data;
};

export const getUpcomingDriverBirthdays = async (
  token: string,
  daysAhead = 30
) => {
  const { data } = await axios.get<DriverDto[]>(
    `${apiVariable}/getUpcomingDriverBirthdays?daysAhead=${daysAhead}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};

export const getUpcomingDriverWorkAnniversaries = async (
  token: string,
  daysAhead = 30
) => {
  const { data } = await axios.get<DriverDto[]>(
    `${apiVariable}/getUpcomingDriverWorkAnniversaries?daysAhead=${daysAhead}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
};
